// src/components/common/PageHeader.tsx
import type { LucideIcon } from "lucide-react";

import { Button } from "@/components/ui";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui";

interface PageHeaderProps {
    title: string;
    description?: string;
    action?: {
        label: string;
        description?: string;
        icon?: LucideIcon;
        onClick: () => void;
    };
}

export function PageHeader({
    title,
    description,
    action,
}: PageHeaderProps) {
    return (
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
            <div>
                <h1 className="text-2xl font-bold tracking-tight">{title}</h1>
                {description && (
                    <p className="text-sm text-foreground/80 dark:text-foreground/50 mt-1">
                        {description}
                    </p>
                )}
            </div>
            {action && (
                <div className="flex flex-col gap-2 w-full md:w-auto">
                    <Tooltip>
                        <TooltipTrigger asChild>
                            <Button
                                className="flex items-center gap-2 bg-ps-blue-400 hover:bg-ps-blue-500 text-white whitespace-nowrap"
                                onClick={action.onClick}
                            >
                                {action.icon && <action.icon className="h-4 w-4" strokeWidth={1.5} />}
                                <span>{action.label}</span>
                            </Button>
                        </TooltipTrigger>
                        {action.description && (
                            <TooltipContent>
                                <p className="text-xs">{action.description}</p>
                            </TooltipContent>
                        )}
                    </Tooltip>
                </div>
            )}
        </div>
    );
} 